import { RefObject, useCallback } from "react";

import useStickyRow from "ds/components/Table/hooks/useStickyRow";
import { TableColumnMeta } from "ds/components/Table/types";
import { StackPullRequestItem } from "shared/Stack/useStackPullRequests/gql";
import { VcsProvider } from "types/generated";

import StackPullRequestsTableRowPullRequest from "./Row/PullRequest";

type StackPullRequestsTableStickyParentRowProps = {
  pullRequest: StackPullRequestItem;
  stackId: string;
  stackProvider: VcsProvider;
  isAnsible: boolean;
  isExpanded: boolean;
  columns: TableColumnMeta[];
  isFirstColumnPinned: boolean;
  keyboardProps: Record<string, unknown>;
  measureRef: (node: HTMLDivElement | null) => void;
  dataIndex: number;
  isActiveSticky: boolean;
  nextAfterSticky?: number;
  tableRef: RefObject<HTMLDivElement | null>;
};

const StackPullRequestsTableStickyParentRow = ({
  pullRequest,
  stackId,
  stackProvider,
  isAnsible,
  isExpanded,
  columns,
  isFirstColumnPinned,
  keyboardProps,
  measureRef,
  dataIndex,
  isActiveSticky,
  nextAfterSticky,
  tableRef,
}: StackPullRequestsTableStickyParentRowProps) => {
  const rowRef = useStickyRow(isActiveSticky, nextAfterSticky, tableRef);

  const setRef = useCallback(
    (node: HTMLDivElement | null) => {
      measureRef(node);
      rowRef.current = node;
    },
    [measureRef, rowRef]
  );

  return (
    <StackPullRequestsTableRowPullRequest
      pullRequest={pullRequest}
      stackId={stackId}
      stackProvider={stackProvider}
      isAnsible={isAnsible}
      columns={columns}
      isFirstColumnPinned={isFirstColumnPinned}
      keyboardProps={keyboardProps}
      measureRef={setRef}
      dataIndex={dataIndex}
      isGroupOpen={isActiveSticky}
      isExpanded={isExpanded}
    />
  );
};

export default StackPullRequestsTableStickyParentRow;
